<script setup lang="ts">
</script>

<template>
  <div class="menu">
    <slot />
  </div>
</template>

<style lang="scss">
.menu {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  line-height: 32px;

  @media(max-width: 599px) {
    left: inherit;
    top: 50%;
    margin-top: -15px;
  }

  font-family: var(--font-primary);

  :deep(.v-icon) {
    position: absolute;
    top: 28px;
    right: 0;
    cursor: pointer;
  }
}
</style>